const AppUrls = {
  TermsOfUse: '/terms-of-use',
  TermsOfSale: '/terms-of-sale',
};

export { AppUrls };
